import { BasicResponse, Error } from "./basic-response";

export class TokenResponse extends BasicResponse {
  public access_token: string | null | undefined;
  public refresh_token: string | null | undefined;
}

